import { t } from '@lingui/core/macro'
import React from 'react'
import { Accordion, Divider, Tooltip } from '@tecsinapse/cortex-react'
import { TriggerAccordion } from './trigger-accordion'
import { FaQuestionCircle } from 'react-icons/fa'
import { FormMultiSelect } from '../../hook-form-connectors/form-multi-select'
import { useDepartamentos } from '../hooks/use-departamentos'

interface AccordionDepartamentosProps {
  possuiDepartamentos?: boolean
}

export const AccordionDepartamentos = ({
  possuiDepartamentos
}: AccordionDepartamentosProps) => {
  const { DepartamentosOptions } = useDepartamentos()

  return (
    <div className={'mt-deca border border-secondary-light rounded-mili '}>
      <Accordion.Face direction={'vertical'}>
        <TriggerAccordion
          labelCheboxbox={t`Por Departamento`}
          idCheckbox={'possuiDepartamentos'}
          value={possuiDepartamentos}
          fieldToClear='Departamentos'
        />
        <Accordion.Content direction={'vertical'}>
          <Divider />
          <div className={'p-deca h-[15rem]'}>
            <div className={'sm:w-[50%] flex items-center gap-2'}>
              <FormMultiSelect
                name='departamentos'
                label={t`Departamento`}
                options={DepartamentosOptions}
                className='col-span-1'
                withSearch
              />
            </div>
          </div>
        </Accordion.Content>
      </Accordion.Face>
    </div>
  )
}
